<template>
  <div class="index">
    <div class="index-con">
      <div class="big-title">
        <span>Special Sessions and Organisers</span>
      </div>



      <div class="small-title sb-title mt-50">SS1-SS3 on Control, Robotics and Embodied AI</div>

      <div class="small-title sb-title mt-50">SS4:Artificial Intelligence for NDT</div>
      <div class="text">
        Qiang WANG, China Jiliang University, China
        <br />
        Xiaokang Yin, China University of Petroleum (East China)
      </div>
      <div class="small-title sb-title mt-50">SS5:Industrial Measurement & Control Networks and Systems</div>
      <div class="text">
        Wenyi LIU, North University of China
        <br />
        Nila NILAVALAN, Brunel University of London, UK
      </div>
      <div class="small-title sb-title mt-50">SS6:Advanced Manufacturing and Artificial Intelligence</div>
      <div class="text">
        QingPing YANG, Brunel University of London, UK
        <br />
        Tianjian LI, University of Shanghai for Science and Technology, China
      </div>

      <div class="small-title sb-title mt-50">SS7:Intelligent Quality Management</div>
      <div class="text">
        Xinsheng XU, China Jiliang University, China

      </div>
      <div class="small-title sb-title mt-50">
        SS8:Artificial Intelligence in Societies
      </div>
      <div class="text">
        Fang WANG, Brunel University of London, UK <br>
        Chenyang ZHU, Changzhou University, China <br>
        Qiwei CHEN, Global Banking School, UK <br>
        Jun XIAO, Shanghai Open University, China <br>
        Faye WANG, Brunel University of London, UK
      </div>
      <div class="small-title sb-title mt-50">SS9:Tipping Points in Complex Systems</div>
      <div class="text">
        Valerie LIVINA, National Physical Laboratory (NPL), UK
        <br />
        Ivan SUDAKOW, Open University, UK
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          one: "Delegate",
          two: "USD 450",
          three: "USD 500",
        },
        {
          one: "Student",
          two: "USD 220",
          three: "USD 250",
        },
        {
          one: "Accompanying person",
          two: "USD 150",
          three: "USD 150",
        },
      ],
    };
  },
  mounted() {
    console.log(window.localStorage.getItem("language"));
  },
  methods: {
    twoheader(h, { column, $index }) {
      return h("div", {}, [
        h("div", {}, column.label.split("aaa")[0]),
        h("div", {}, column.label.split("aaa")[1]),
      ]);
    },
    toReg() {
      this.$router.push("/register1");
    },
    toLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.sb-title {
  color: #0270c0 !important;

}

.mt-50 {
  margin-top: 50px;
}

.d-flex {
  display: flex;
  justify-content: space-between;
}

.w-50 {
  width: calc(50% - 30px);
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 20px;
  box-sizing: border-box;
}

.pb-10 {
  padding-bottom: 10px !important;
  line-height: 1.4 !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.btns {
  display: flex;
  margin-bottom: 20px;
}

.btn {
  margin-right: 20px;
  padding: 0 20px;
  background: #0a9a7a;
  height: 40px;
  line-height: 40px;
  display: inline-block;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
}

.btn-reg {
  cursor: no-drop;
  background: #999;
}

.btn-login {
  background-color: rgb(55, 122, 245);
}

.text-blue {
  color: rgb(55, 122, 245);
}

.mt-30 {
  margin-top: 30px;
}

.email {
  cursor: pointer;
  color: rgb(30, 98, 222);
  font-weight: 600;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
  padding-bottom: 170px;
}

.text {
  box-sizing: border-box;
  color: #333;
  font-size: 16px;
  line-height: 2;
  padding-bottom: 20px;
}

.w-350 {
  width: 350px;
  margin: 0 auto;
  text-indent: 0;
  text-align: center;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

.small-title_2 {
  font-size: 17px;
  font-weight: 600;
}

.text-333 {
  color: #333 !important;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .nav {
    width: 100%;
  }

  .title {
    font-size: 18px;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }

  .d-flex {
    display: block;
  }

  .w-50 {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/organizingCommittees.vue